import * as allTypes from '../mutation-type';
import * as types from './contacts-mutation-type';
import cloneDeep from 'lodash/cloneDeep';
import {
  postContact,
  getContactClient,
  updateContact,
} from '@/api/contacts/index';

const contactInitial = {
  tiersId: null,
  nom: '',
  prenom: '',
  fonction: '',
  service: '',
  adresseContactDifferente: false,
  adresse: {
    adresse1: '',
    adresse2: '',
    adresse3: '',
    pays: '',
    ville: '',
    codePostal: '',
    intitule1: '',
    intitule2: '',
    intitule3: '',
    latitude: 0,
    longitude: 0,
  },
  telephone: '',
  portable: '',
  email: '',
  siteWeb: '',
  archive: false,
  civiliteId: null,
  typeContactId: null,
  newsletter: false,
}

function initialState() {
  return {
    contact: cloneDeep(contactInitial),
    contacts: [],
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_PROPRIETY_CONTACT](state, { key, value }) {
    state.contact[key] = value;
  },
  [types.SET_CONTACT](state, contact) {
    state.contact = contact;
  },
  [types.RESET_CONTACT](state) {
    state.contact = cloneDeep(contactInitial);
  },
  [types.VIDE_CONTACTS](state) {
    state.contacts = [];
  },
  [types.SET_CONTACTS](state) {
    const index = state.contacts.findIndex(contact => contact.id === state.contact.id);
    if (index >= 0) {
      state.contacts.splice(index, 1, state.contact);
    } else {
      const id = state.contacts.length;
      state.contacts.push({...state.contact, id});
    }
    state.contact = cloneDeep(contactInitial);
  },
  [types.SET_MANY_CONTACTS](state, data) {
    state.contacts = data;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  createContact: async({state, commit }, id) => {
  try {
    let contacts = cloneDeep(state.contacts);
    const reqests = [];
    contacts.forEach((contact) => {
      contact.tiersId = id;
      reqests.push(postContact(contact));
    });
    await Promise.all(reqests);
    commit(types.VIDE_CONTACTS);
    return true;
  } catch (e) {
    return e;
  }
},
  editContact: async({ state, commit }) => {
    try {
      await updateContact(state.contact);
      commit(types.RESET_CONTACT);
      return true;
    } catch (e) {
      return e;
    }
  },
  setContactsTiers: async({ commit }, payload) => {
    try {
      const res = (await getContactClient(payload.id)).data;
      const contacts = [];
      res.forEach(contact => {
        const contactInit = cloneDeep(contactInitial);
        contactInit.tiersId = contact.id;
        contactInit.nom = contact.nom;
        contactInit.prenom = contact.prenom;
        contactInit.fonction = contact.fonction;
        contactInit.service = contact.service;
        contactInit.telephone = contact.telephone;
        contactInit.portable = contact.portable;
        contactInit.email = contact.email;
        contactInit.siteWeb = contact.siteWeb;
        contactInit.archive = contact.archive;
        contactInit.civiliteId = contact.civiliteId;
        contactInit.typeContactId = contact.typeContactId;
        contactInit.adresseContactDifferente = contact.adresseContactDifferente;
        contactInit.adresse.adresse1 = contact.adrLibelle1;
        contactInit.adresse.adresse2 = contact.adrLibelle2;
        contactInit.adresse.adresse3 = contact.adrLibelle3;
        contactInit.adresse.ville = contact.ville;
        contactInit.adresse.pays = contact.pays;
        contacts.push(contact);
      })
      commit(types.SET_MANY_CONTACTS, contacts);
      return true;
    } catch (e) {
      return e;
    }
  },
};

const getters = {
  contact: state => {
    return state.contact;
  },
  contacts: state => {
    return state.contacts;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
